<template>
  <v-dialog v-model="openDialog" max-width="707px" scrollable>
    <v-card class="email-preview-card">
      <v-card-title> <span class="title-preview mb-3">Enviar preview</span> </v-card-title>
      <v-card-subtitle
        ><p class="subtitle mb-0">
          Selecione uma lista de e-mails para receber uma preview do modelo de e-mail criado para essa campanha. O modelo é identico ao que será enviado para os
          consumidores, caso haja alguma inconsistência, você pode edita-lo antes de ativar a campanha.
        </p></v-card-subtitle
      >
      <v-card-text class="pa-0">
        <v-row class="mx-3">
          <v-col cols="12" class="d-flex align-center pt-0 pb-2">
            <mf-icon fill color="vermelho-d20">warning</mf-icon>
            <p class="warning-text ma-0 pl-3">Os envio de preview realizados consumirão créditos de e-mail da sua conta.</p>
          </v-col>
          <v-col cols="12">
            <h3 class="pb-0">Incluir contatos</h3>
          </v-col>
          <v-col class="pb-0">
            <v-text-field v-model="contact.name" dense height="44" :error-messages="errorMessage.name" outlined placeholder="Nome" />
          </v-col>
          <v-col class="pb-0" cols="5">
            <v-text-field
              v-model="contact.email"
              dense
              height="44"
              :error-messages="errorMessage.email"
              outlined
              placeholder="E-mail"
              @keyup.enter="addContacts"
            />
          </v-col>
          <v-col class="pb-0" cols="3">
            <mf-button outlined size="lg" label="Adicionar" @click="addContacts" />
          </v-col>
        </v-row>
        <v-data-table
          class="ml-6 mr-5"
          fixed-header
          disable-pagination
          hide-default-footer
          :headers="headers"
          :items="emails"
          :height="emails.length > 3 ? '192px' : ''"
          :loading="loadingDefaultEmails"
          no-data-text="Nenhum contato com e-mail adicionado"
        >
          <template v-slot:header.name="{ header }">
            <span>Nome</span>
          </template>
          <template v-slot:header.email="{ header }">
            <span>E-mail</span>
          </template>
          <template v-slot:header.action="{ header }">
            <delete-email remove-all-emails @remove-email="clearEmailPreviewList" />
          </template>
          <template v-slot:item="{ item, index }">
            <tr>
              <td class="nowrap-row">
                <v-tooltip max-width="250" top>
                  <template #activator="{ on }">
                    <span v-on="on">
                      {{ getFormatedText(item.name) }}
                    </span>
                  </template>
                  <span>{{ item.name }}</span>
                </v-tooltip>
              </td>
              <td class="nowrap-row">
                <v-tooltip max-width="450" top>
                  <template #activator="{ on }">
                    <span v-on="on">
                      {{ item.email | truncate({ length: 40 }) }}
                    </span>
                  </template>
                  <span>{{ item.email }}</span>
                </v-tooltip>
              </td>
              <td class="text-end">
                <delete-email @remove-email="deleteContacts(index)" />
              </td>
            </tr>
          </template>
        </v-data-table>
        <mf-action-buttons
          class="py-1"
          :primary-button="{
            text: 'Enviar',
            action: sendEmailPreview,
            isVisible: true,
            isLoading: sendLoading,
          }"
          :secondary-button="{
            text: 'Cancelar',
            action: closeEmailPreview,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import truncate from 'lodash/truncate'
import cloneDeep from 'lodash/cloneDeep'
import { QUERY_CAMPAIGNS_EXTRA_NUMBERS } from '@/modules/configuracoes/gerais/graphql'
import { MUTATION_EMAIL_PREVIEW } from '@/modules/campanhas/campanhas-email/graphql'
import { required, email, minLength } from 'vuelidate/lib/validators'
import DeleteEmail from '@/components/export-email-report/DeleteEmail'

const hasTwoWords = (value) => value && value.split(' ').filter((word) => word.length).length >= 2
export default {
  name: 'SendEmailPreviewModal',
  components: {
    DeleteEmail,
  },
  props: {
    campaign: Object,
    value: Boolean,
    mariaCampaignVariables: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    emails: [],
    loadingDefaultEmails: false,
    sendLoading: false,
    contact: {},
    errorMessage: {
      name: '',
      email: '',
    },
    errors: {
      name: {
        required: 'Campo obrigatorio.',
        minLength: 'O título possui menos de 3 caracteres.',
        hasTwoWords: 'Deve ter pelo menos 2 nomes.',
      },
      email: {
        required: 'Campo obrigatorio.',
        email: 'E-mail inválido',
      },
    },
    validationArray: ['name', 'email'],
  }),
  computed: {
    openDialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    headers() {
      return [
        {
          text: 'Nome',
          value: 'name',
          width: '22.5%',
          sortable: false,
        },
        {
          text: 'E-mail',
          value: 'email',
          width: '40%',
          sortable: false,
        },
        {
          text: 'Limpar lista',
          value: 'action',
          width: '15%',
          sortable: false,
          align: 'right',
        },
      ]
    },
  },
  mounted() {
    this.loadEmailsContacts()
  },
  methods: {
    getFormatedText(text) {
      return truncate(text, {
        length: 24,
        separator: ' ',
      })
    },
    async loadEmailsContacts() {
      try {
        this.loadingDefaultEmails = true
        let query = []
        const { data } = await this.$apollo.query({
          query: QUERY_CAMPAIGNS_EXTRA_NUMBERS,
          variables: {
            page: 1,
          },
          fetchPolicy: 'no-cache',
        })
        query = data.campaignsExtraNumbers.campaignsExtraNumbers
        query.forEach((element) => {
          if (element.email) {
            this.emails.push({ name: element.name, email: element.email })
          }
        })
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar emails', snackbarColor: 'error' })
      } finally {
        this.loadingDefaultEmails = false
      }
    },
    async sendEmailPreview() {
      try {
        this.sendLoading = true
        if (this.emails.length > 0) {
          const variables = {
            contacts: this.emails,
            processed_html: this.campaign.message.processed_html,
            subject: this.campaign.message.subject,
          }
          if (this.mariaCampaignVariables) variables.variables = this.mariaCampaignVariables
          const { data } = await this.$apollo.mutate({
            mutation: MUTATION_EMAIL_PREVIEW,
            variables: variables,
            context: {
              uri: this.$microservicesUrls['campaigns'],
            },
            fetchPolicy: 'no-cache',
          })
          this.openDialog = false
          if (data?.sendPreviewMessageEmail) {
            this.$snackbar({ message: 'Preview de e-mail enviado com sucesso', snackbarColor: 'success' })
          } else {
            this.$snackbar({ message: 'Falha ao enviar preview de e-mail', snackbarColor: 'error' })
          }
        } else {
          this.$snackbar({ message: 'É necessário ter ao menos um contato adicionado para enviar a preview.', snackbarColor: 'error' })
        }
      } catch (error) {
        this.$snackbar({ message: 'Erro ao enviar preview de e-mail', snackbarColor: 'error' })
      } finally {
        this.sendLoading = false
      }
    },
    closeEmailPreview() {
      this.openDialog = false
      this.sendLoading = false
    },
    addContacts() {
      this.$v.$touch()

      this.validationArray.forEach((validation) => {
        if (!this.$v.contact[validation].required && this.$v.contact[validation].$invalid) {
          this.errorMessage[validation] = this.errors[validation].required
          return
        }
        if (!this.$v.contact[validation].minLength && validation !== 'email') {
          this.errorMessage[validation] = this.errors[validation].minLength
          return
        }
        if (validation === 'name' && !this.$v.contact[validation].hasTwoWords) {
          this.errorMessage[validation] = this.errors[validation].hasTwoWords
          return
        }
        if (validation === 'email' && !this.$v.contact[validation].email) {
          this.errorMessage[validation] = this.errors[validation].email
          return
        }
        this.errorMessage[validation] = ''
      })
      if (this.$v.$error) {
        return
      }
      this.emails.unshift(this.contact)
      this.contact = {
        name: '',
        email: '',
      }
    },
    deleteContacts(index) {
      const list = cloneDeep(this.emails)
      list.splice(index, 1)
      this.emails = list
    },
    clearEmailPreviewList() {
      this.emails = []
    },
    validateFields() {
      this.$v.$reset()
      this.$v.$touch()
      if (!this.emails.length) {
        this.errorEmail = 'Este campo é obrigatório'
        this.$snackbar({ message: 'Preencha todos os campos corretamente.', snackbarColor: 'error' })
      } else this.errorEmail = ''
    },
    openModal() {
      this.dialog = true
    },
  },
  validations() {
    return {
      contact: {
        name: {
          required,
          minLength: minLength(3),
          hasTwoWords,
        },
        email: {
          required,
          email,
        },
      },
    }
  },
}
</script>
<style lang="scss" scoped>
::v-deep th,
::v-deep td {
  font-size: 14px !important;
  color: $cinza-d20 !important;
}
::v-deep td {
  height: 40px !important;
}
.email-preview-card {
  .title-preview {
    font-weight: 700;
    font-size: 26px;
    color: $cinza-d10;
    font-family: 'Lato', sans-serif;
  }
  .subtitle-preview {
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0.4px;
    font-family: 'Lato', sans-serif;
    color: $cinza-0;
  }
  h3 {
    font-weight: 400;
    font-size: 18px;
    color: $cinza-d10;
  }
  .warning-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: $cinza-0;
  }
}
</style>
